/* this file is transformed by vux-loader */
/* eslint-disable */
import Vue from 'vue';
import VueRouter from 'vue-router';
var _import = require('./_import_' + process.env.NODE_ENV); // 生产环境使用路由懒加载，开发环境懒加载热更新很慢
Vue.use(VueRouter);
var routes = [{
  path: '/login',
  name: 'Login',
  component: _import('login/index'),
  hidden: true
}, {
  path: '/404',
  name: 'NotFound',
  component: _import('404'),
  hidden: true
}, {
  path: '/',
  // 首页
  name: 'Index',
  component: _import('index/index'),
  hidden: true
},
// {
//   path: '/indexDetail', // 首页详情
//   name: 'IndexDetail',
//   component: _import('index/indexDetail'),
//   hidden: true
// },
{
  path: '/me',
  // 我的详情
  name: 'Me',
  component: _import('me/index'),
  hidden: true,
  meta: {
    title: '我的'
  }
}, {
  path: '/examine',
  // 审核
  component: _import('examine/index'),
  name: 'Examine',
  hidden: true,
  meta: {
    title: '审核'
  } // title需要与语言包里的字段相对应
}, {
  path: '/examineDetail',
  // 审核详情
  component: _import('examine/detail'),
  name: 'ExamineDetail',
  hidden: true,
  meta: {
    title: '审核详情'
  }
}, {
  path: '/feedback',
  // 问题反馈
  component: _import('feedback/index'),
  name: 'Feedback',
  hidden: true,
  meta: {
    title: '问题反馈'
  }
}, {
  path: '/problemHandling',
  // 问题处理
  component: _import('problemHandling/index'),
  name: 'ProblemHandling',
  hidden: true,
  meta: {
    title: '问题处理'
  } // title需要与语言包里的字段相对应
}, {
  path: '/problemHandlingDetail',
  // 问题处理详情
  component: _import('problemHandling/detail'),
  name: 'ProblemHandlingDetail',
  hidden: true,
  meta: {
    title: '问题处理详情'
  }
}];
var router = new VueRouter({
  routes: routes
});
export default router;